import React, { Component } from "react";
import SvgIcon from "material-ui/SvgIcon";

class EditPage extends Component {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path d="M12.6,6.4h2.3c0.4,0,0.6-0.5,0.3-0.8l-2.3-2.4c-0.3-0.3-0.7-0.1-0.7,0.3V6C12.1,6.2,12.3,6.4,12.6,6.4z" />
                <path
                    d="M16.1,11.7c-0.1-0.1-0.3-0.1-0.4,0l-4.4,4.8c-0.1,0.1-0.1,0.3,0,0.4l2.1,2.4c0.1,0.1,0.3,0.1,0.4,0l4.5-4.8
                    c0.1-0.1,0.1-0.3,0-0.4L16.1,11.7z"
                />
                <path
                    d="M20.1,11l-1.3-1.3c-0.6-0.7-1.3,0-1.3,0l-0.8,0.8c-0.1,0.1-0.1,0.3,0,0.4l2.2,2.3c0.1,0.1,0.3,0.1,0.4,0
                    l0.8-0.8C20.9,11.7,20.1,11,20.1,11z"
                />
                <path
                    d="M10.6,17.9c-0.1-0.2-0.4-0.1-0.5,0.1l-1.2,3.1c-0.1,0.2,0.1,0.5,0.4,0.4l3-1c0.2-0.1,0.3-0.3,0.1-0.5
                    L10.6,17.9z"
                />
                <path
                    d="M8.8,16.5H4.9c-0.2,0-0.3-0.1-0.3-0.3v-0.7c0-0.2,0.1-0.3,0.3-0.3H10c0.3,0,0.5-0.1,0.7-0.3l0.8-0.8
                    c0.1-0.2,0-0.4-0.2-0.4H4.9c-0.2,0-0.3-0.1-0.3-0.3v-0.7c0-0.2,0.1-0.3,0.3-0.3h8.1l1.3-1.4c0,0,0.2-0.2-0.1-0.2H4.9
                    c-0.2,0-0.3-0.1-0.3-0.3V9.8c0-0.2,0.1-0.3,0.3-0.3h9.5c0.2,0,0.3,0.1,0.3,0.3v0.4c0,0.1,0.2,0.2,0.3,0.1c0.3-0.3,0.6-0.7,0.8-0.9
                    c0.1-0.1,0.1-0.1,0.1-0.2V8.2c0-0.2-0.2-0.4-0.4-0.4h-4.1c-0.2,0-0.4-0.2-0.4-0.4V2.9c0-0.2-0.2-0.4-0.4-0.4H3.9
                    c-0.2,0-0.4,0.2-0.4,0.4v14.8c0,0.2,0.2,0.4,0.4,0.4h4c0.3,0,0.6-0.2,0.7-0.5l0.1-0.3C8.8,17.3,8.9,17.1,9,17
                    C9.1,16.8,9,16.5,8.8,16.5z M4.6,4.1c0-0.2,0.1-0.3,0.3-0.3h4.4c0.2,0,0.3,0.1,0.3,0.3v0.7c0,0.2-0.1,0.3-0.3,0.3H4.9
                    C4.8,5.1,4.6,5,4.6,4.8V4.1z M4.6,7c0-0.2,0.1-0.3,0.3-0.3h4.4c0.2,0,0.3,0.1,0.3,0.3v0.7C9.7,7.8,9.5,8,9.4,8H4.9
                    C4.8,8,4.6,7.8,4.6,7.7V7z"
                />
            </SvgIcon>
        );
    }
}

export default EditPage;
